import { render, staticRenderFns } from "./disinfectionService.vue?vue&type=template&id=76ca82d8&scoped=true&"
import script from "./disinfectionService.vue?vue&type=script&lang=js&"
export * from "./disinfectionService.vue?vue&type=script&lang=js&"
import style0 from "./disinfectionService.vue?vue&type=style&index=0&id=76ca82d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ca82d8",
  null
  
)

export default component.exports